import axios from 'axios/index'

const namespaced = true

const state = {}
const getters = {}
const actions = {
  createOrganization ({ commit }, data) {
    return new Promise(function (resolve, reject) {
      axios({
        method: 'POST',
        url: '/api/private/v3.0/otvt-groups-users/',
        data: data
      })
        .then(response => {
          resolve()
        })
        .catch(error => {
          reject(error)
        })
    })
  }
}
const mutations = {}

export default {
  namespaced,
  state,
  actions,
  mutations,
  getters
}
